import { PUBLISHER_URL } from "../../../config/envConfig";
import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const publisherAPIInstance = APIService({
  baseURL: PUBLISHER_URL,
});

publisherAPIInstance.interceptors.request.use((config) => {
  config.headers["Authorization"] = LocalStorage.getItem("authToken");

  return config;
});

export default publisherAPIInstance;
